import Category from '@shared/classes/category';
import Event from '../../../classes/event';
import Focus from '../../../types/enums/focus';
import Main from '../../../types/enums/main';
import Rail from '../../../../shared/classes/rail';
import Slider from '../../../../shared/classes/slider';
import { createContext, Dispatch, SetStateAction } from 'react';

interface Props {
  animation?: {
    horizontal?: boolean;
    vertical?: boolean | Focus;
  };
  asset?: Event;
  complete: boolean;
  display?: {
    background: boolean;
    description: boolean;
    empty: boolean;
    sliders: boolean;
  };
  hasFilters?: boolean;
  filter?: Category;
  hidePreviousItem?: boolean;
  index?: React.MutableRefObject<number>;
  prevFocus?: Focus | Focus[];
  rails?: Rail[];
  sliders?: Slider[];
  onChangeElement: (
    type: Main,
    hIndex: number | null,
    vIndex?: number,
    animationOffset?: number,
    focus?: number | (string | number)[] | number[] | null
  ) => void;
  onItemClick?: (
    horizontalIndex: number,
    verticalIndex: number,
    previousFocus: number | (string | number)[] | number[] | null
  ) => void;
  outOfBoundsAction: (
    outOfFocusList: Focus | number | string,
    key?: string
  ) => void;
  setAsset: (asset: Event | undefined) => void;
  setFilter: Dispatch<SetStateAction<Category | undefined>>;
  setCurrentIndex?: Dispatch<SetStateAction<number>>;
}

const MainContext = createContext<Props>({
  animation: undefined,
  asset: undefined,
  complete: false,
  display: {
    background: false,
    description: false,
    empty: false,
    sliders: false,
  },
  filter: undefined,
  hasFilters: false,
  hidePreviousItem: undefined,
  index: undefined,
  prevFocus: undefined,
  rails: undefined,
  sliders: undefined,
  onChangeElement: () => null,
  onItemClick: () => null,
  outOfBoundsAction: () => null,
  setAsset: () => null,
  setFilter: () => null,
  setCurrentIndex: () => null,
});

export default MainContext;
export type { Props };
